// Turns each word that belongs to a synonym group (theme setting "Search synonyms") into an OR group,
// e.g. "hår shampoo" -> "(hair OR hår) shampoo". The typed word goes last so Shopify's prefix
// matching on the last term still applies to it.
function getSearchSynonymGroups() {
  if (!window.searchSynonymGroups) {
    window.searchSynonymGroups = (window.searchSynonyms || '')
      .split('\n')
      .map((line) =>
        line
          .split(',')
          .map((word) => word.trim().toLowerCase())
          .filter(Boolean)
      )
      .filter((group) => group.length > 1);
  }
  return window.searchSynonymGroups;
}

function expandSearchQuery(query) {
  const groups = getSearchSynonymGroups();
  // Leave queries that already use search syntax alone
  if (!groups.length || /[()":]|\b(OR|AND|NOT)\b/.test(query)) return query;

  return query
    .split(/\s+/)
    .map((word) => {
      const group = groups.find((group) => group.includes(word.toLowerCase()));
      if (!group) return word;

      const alternatives = group
        .filter((synonym) => synonym !== word.toLowerCase())
        .map((synonym) => (synonym.includes(' ') ? `"${synonym}"` : synonym));
      return `(${[...alternatives, word].join(' OR ')})`;
    })
    .join(' ');
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmit(event) {
    // A selected predictive search result is opened instead of submitting the form
    if (event.defaultPrevented || this.input.form.querySelector('[aria-selected="true"] a')) return;

    const query = this.input.value.trim();
    const expandedQuery = expandSearchQuery(query);
    if (expandedQuery === query) return;

    // Submit the expanded query without changing what's shown in the input
    event.preventDefault();
    const formData = new FormData(this.input.form);
    formData.set(this.input.name, expandedQuery);
    window.location.href = `${this.input.form.action}?${new URLSearchParams(formData)}`;
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
